<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { TRANSITION_DELAY } from '$lib/global/constants';

    import ListItem from './ListItem.svelte';
    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import Box from '../_wrappers/Box.svelte';

    import type { ListItemProps } from '$lib/types/Components/List/ListItemProps';
    import type {
        Align,
        Box as BoxType,
        TextSize,
        VisualSize,
    } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let box: BoxType;
    export let listItems: ListItemProps[] = [];
    export let align: Align = 'left';
    export let textSize: TextSize = 'small';
    export let visualSize: VisualSize = 'small';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;

    const { isInColumn, isInSingleColumn } = layout;

    const hasSingleItem = listItems.length === 1;

    const isSingleColumn = hasSingleItem || (isInColumn && !isInSingleColumn);
</script>

<Box {id} {...getBoxAttributes({ box, isInColumn })} {transitionDelay} transitionEffect="none">
    <div
        class="fun-grid fun-grid-cols-1 fun-gap-6 fun-text-left {!isSingleColumn &&
            'md:fun-grid-cols-2'}"
    >
        {#each listItems as listItem, index (listItem.id)}
            <ListItem
                {...listItem}
                {align}
                {textSize}
                {visualSize}
                {transitionEffect}
                transitionDelay={transitionDelay + index * TRANSITION_DELAY}
            />
        {/each}
    </div>
</Box>
